/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import { StorageModule } from '@vlinder-web/storage-module-react';
import jwt_decode from 'jwt-decode';
import toast from 'react-hot-toast';

export interface IAuthMethods extends IPluginMethodMap {
  getTokenSync(args: any): any;
}

export class AuthService implements IAgentPlugin {
  readonly methods: IAuthMethods;

  constructor() {
    this.methods = {
      getTokenSync: this.getToken.bind(this),
    };
  }

  getToken(args: any) {
    //TODO: FIX ME
    const storageService = StorageModule.getInstance();
    const localToken = storageService.get('userProfile', 'local');
    const sessionToken = storageService.get('userProfile', 'session');
    const token = localToken?.accessToken ?? sessionToken?.accessToken;
    let f = 0;
    console.log(`token in service`, token);
    // useNavigate()('/');
    if (token) {
      const _validToken = this.getValidToken(token);
      return _validToken;
    } else if (
      window.location.pathname !== '/payment' &&
      window.location.pathname !== '/payment-success' &&
      window.location.pathname !== '/payment-failed'
    ) {
      if (
        f === 0 &&
        window.location.pathname !== '/' &&
        window.location.pathname !== '/sign-in' &&
        window.location.pathname !== '/sign-up' &&
        window.location.pathname !== '/forgot-password' &&
        window.location.pathname !== '/reset-password' &&
        window.location.pathname !== '/register' &&
        window.location.pathname !== '/email' &&
        window.location.pathname !== '/password-reset-token' &&
        window.location.pathname !== '/scooby-iam'
      ) {
        f = 1;
        toast.error('Session expired! Please Log in again');
        setTimeout(() => {
          window.location.href = '/';
        }, 2000);
        // window.location.href = '/';

        // window.location.assign('/');
      }
      storageService.reset('local');
      storageService.reset('session');
      return null;
    }
  }

  private getValidToken(token: string) {
    let decodedToken: any = jwt_decode(token);
    let currentDate = new Date();

    if (decodedToken?.exp * 1000 > currentDate.getTime()) {
      return token;
    } else {
      return null;
    }
  }
}
